// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-templates-markdown-template-js": () => import("./../src/templates/markdownTemplate.js" /* webpackChunkName: "component---src-templates-markdown-template-js" */),
  "component---src-pages-404-js": () => import("./../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-application-js": () => import("./../src/pages/application.js" /* webpackChunkName: "component---src-pages-application-js" */),
  "component---src-pages-blog-js": () => import("./../src/pages/blog.js" /* webpackChunkName: "component---src-pages-blog-js" */)
}

